
// Mini popup 
try {
    let miniPopup = document.querySelector('.products__popup');
    let miniPopupCloseButton = document.querySelector('.js-eyeglasses-popup-close');
    let popupActiveStatus = window.localStorage.getItem('orgreen-eyeglasses-popup');
    
    if(popupActiveStatus === null) {
        setTimeout(() => {
            miniPopup.classList.add('visible')
        }, 3000)
    } else {
        miniPopup.classList.remove('visible')
    }

    miniPopupCloseButton.addEventListener('click', () => {
        miniPopup.classList.remove('visible')
        window.localStorage.setItem('orgreen-eyeglasses-popup', false);
    })

} catch(err) {
    console.log(err)
}